export var SEPARATOR = '.';
export var NUM_ANALYSIS = ['average', 'minimum', 'maximum', 'median', 'sum', 'standard_deviation', 'percentile'];
export var NUM_ANALYSIS_MAP = {
  average: 'Average',
  minimum: 'Minimum',
  maximum: 'Maximum',
  median: 'Median',
  sum: 'Sum',
  standard_deviation: 'Standard_deviation',
  percentile: 'Percentile'
};